import styled from 'styled-components/macro';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 280px;
  height: 150px;
  padding: 15px;
  cursor: default;
`;

export default Wrapper;
